import React from 'react';
import { Phone, AlertTriangle, Wrench, Settings } from 'lucide-react';
export function PowerStroke60LPage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-7496">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-16" data-id="element-7497">
        <div className="container mx-auto px-4" data-id="element-7498">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-7499">
            Ford 6.0 Powerstroke Engine Repair
          </h1>
          <p className="text-xl text-gray-100 text-center" data-id="element-7500">
            6.0L Powerstroke Turbo Diesel Inspection, Diagnostics and Repair by
            Certified Diesel Mechanics
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12" data-id="element-7501">
        <div className="max-w-4xl mx-auto" data-id="element-7502">
          {/* Three Engine Models */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7503">
            <div className="grid md:grid-cols-3 gap-6 mb-8" data-id="element-7504">
              <div className="text-center" data-id="element-7505">
                <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/7.3.jpg?opt=w3" alt="7.3 liter diesel engines repaired" title="7.3L Powerstroke Engine" className="w-full h-auto rounded-lg mb-4" data-id="element-7506" />
                <a href="/services/powerstroke-7-3" className="text-lg font-bold text-[#B1050B] hover:text-[#8A0408] transition-colors" data-id="element-7507">
                  7.3 Power Stroke
                </a>
                <p className="font-semibold text-gray-700 mt-2" data-id="element-7508">The "Good"</p>
              </div>

              <div className="text-center" data-id="element-7509">
                <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/6.0l.jpg?opt=w3" alt="6.0 liter diesel engines repaired" title="6.0 Powerstroke Engine" className="w-full h-auto rounded-lg mb-4" data-id="element-7510" />
                <p className="text-lg font-bold text-gray-900" data-id="element-7511">
                  6.0 Power Stroke
                </p>
                <p className="font-semibold text-gray-700 mt-2" data-id="element-7512">The "Bad"</p>
              </div>

              <div className="text-center" data-id="element-7513">
                <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/imagesCAB65B34.jpg?opt=w3" alt="6.4 liter diesel engines repaired" title="6.4 Powerstroke Engine" className="w-full h-auto rounded-lg mb-4" data-id="element-7514" />
                <a href="/services/powerstroke-6-4" className="text-lg font-bold text-[#B1050B] hover:text-[#8A0408] transition-colors" data-id="element-7515">
                  6.4 Power Stroke
                </a>
                <p className="font-semibold text-gray-700 mt-2" data-id="element-7516">The "Ugly"</p>
              </div>
            </div>
          </div>

          {/* Common Problems Overview */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7517">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center" data-id="element-7518">
              Common 6.0L Power Stroke Problems
            </h2>

            <div className="flex justify-center mb-6" data-id="element-7519">
              <img src="//drwzpk38qkpfb.cloudfront.net/core/getthumb?file=uploaded%2Fimages%2Ftruck%20pictures%2Fiphone%20import%20008.JPG400x400.jpg&site=1986&w=265&h=319&user=1617&opt=w3" alt="6.0L Powerstroke truck" className="max-w-[265px] h-auto rounded-lg shadow-md" data-id="element-7520" />
            </div>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center" data-id="element-7521">
              6.0L Power Stroke Problems and Consequences
            </h3>

            <p className="text-gray-700 mb-6" data-id="element-7522">
              The 6.0 liter Power Stroke is a great diesel, despite a bundle of
              issues that plagued many of the early engines. The 6.0 is
              powerful, durable, & reliable. There are more than enough
              satisfied 6.0L owners to back those statements up. However, some
              of the 6.0L components are prone to problems, especially when
              maintenance is neglected or the performance is increased by means
              of aftermarket components. When it comes to diesel engines,
              including the Ford 6.0L Powerstroke Turbo Diesel, always get the
              proper maintenance, inspections and repairs as scheduled by the
              manufacturer.
            </p>
          </div>

          {/* TTY Head Bolts */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7523">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center flex items-center justify-center" data-id="element-7524">
              <AlertTriangle className="mr-3 text-[#B1050B]" size={28} data-id="element-7525" />
              6.0L Power Stroke TTY Head Bolts
            </h2>

            <p className="text-gray-700 mb-4" data-id="element-7526">
              The 6.0L Power Stroke uses Torque to yield (TTY) head bolts to
              secure the cylinder heads. The stock TTY head bolts do a mediocre
              job of equalizing the clamping force of the head bolts. The head
              bolts are also much more prone to stretching than head studs, and
              under high cylinder pressures are prone to fail.
            </p>

            <div className="bg-green-50 border-l-4 border-green-500 p-6 mb-4" data-id="element-7527">
              <p className="text-gray-800 mb-4" data-id="element-7528">
                For a 6.0L that remains completely stock, the TTY head bolts are
                suitable. However, for modified engines or engines that are
                under constant load, the stock head bolts are a weak link in the
                6.0L.
              </p>
              <p className="text-gray-800 font-semibold" data-id="element-7529">
                Garrett can replace your stock head bolts with stronger, more
                durable head bolts. Call us if you have any questions and want
                to get the upgraded head bolts installed in your 6.0
                Powerstroke.
              </p>
            </div>

            <p className="text-gray-700" data-id="element-7530">
              Additionally, the EGR system can cause high coolant temperatures
              or turbo overboost situations. High coolant temperatures may cause
              slight warping of the cylinder heads, which can lead to head bolt
              failures. Too much turbo boost can result in increased cylinder
              pressures and cause the TTY bolts to stretch. This causes blown
              head gaskets.
            </p>
          </div>

          {/* EGR System */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7531">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center flex items-center justify-center" data-id="element-7532">
              <Settings className="mr-3 text-[#B1050B]" size={28} data-id="element-7533" />
              6.0L Power Stroke EGR (Exhaust Gas Recirculation)
            </h2>

            <p className="text-gray-700 mb-4" data-id="element-7534">
              The EGR coolers on the 6.0 liter Power Stroke are prone to
              clogging due to oil & soot build up, which can cause them to fail.
              A failed EGR cooler may contribute to high coolant temperatures or
              coolant loss. EGR valves are also notorious for failing due to
              soot build up, which can lead to over-boosting of the
              turbocharger. To prevent this, the EGR valve should be cleaned
              routinely.
            </p>

            <div className="bg-yellow-50 border-l-4 border-yellow-400 p-6 mb-4" data-id="element-7535">
              <p className="text-gray-800 mb-2" data-id="element-7536">
                <strong data-id="element-7537">Prevention Tips:</strong>
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-700" data-id="element-7538">
                <li data-id="element-7539">
                  Avoid excessive idling - reduces combustion temperatures and
                  increases particulate production
                </li>
                <li data-id="element-7540">
                  Use high-quality diesel fuel with minimum cetane level of 45
                </li>
                <li data-id="element-7541">
                  Use Motorcraft fuel additive (recommended and verified safe by
                  Ford)
                </li>
                <li data-id="element-7542">Clean EGR valve routinely</li>
              </ul>
            </div>

            <p className="text-gray-700 mb-4" data-id="element-7543">
              Excessive idling and poor fuel quality can clog the EGR valve
              rapidly. The efficiency of a diesel engine is reduced at idle due
              to low combustion temperatures, resulting in increased particulate
              production. Ford recommends a minimum diesel fuel cetane level of
              45 for maximum quality. Motorcraft manufactures a fuel additive
              for the Power Stroke which is recommended and verified safe by
              Ford Motor Company.
            </p>

            <div className="bg-blue-50 border-l-4 border-blue-500 p-6" data-id="element-7544">
              <p className="text-gray-800" data-id="element-7545">
                <strong data-id="element-7546">Important Note:</strong> EGR valve issues are not
                necessarily a design flaw, but rather due to the nature of a
                diesel engine. EGR cooler issues are related to inadequate
                design. 2004+ EGR coolers are more prone to failure. 2003
                coolers are round, while 2004+ EGR coolers are square (and
                longer than the 2003 cooler).
              </p>
            </div>
          </div>

          {/* Turbocharger */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7547">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center flex items-center justify-center" data-id="element-7548">
              <Wrench className="mr-3 text-[#B1050B]" size={28} data-id="element-7549" />
              6.0L Power Stroke Turbocharger
            </h2>

            <p className="text-gray-700 mb-4" data-id="element-7550">
              The 6.0L Power Stroke is equipped with a variable geometry
              turbocharger (VGT). The 6.0L turbocharger is very efficient &
              provides quick spooling with plenty of airflow through peak RPM.
              However, the vanes of the VGT that control the displacement of the
              turbo are prone to sticking from soot build up.
            </p>

            <div className="bg-red-50 border-l-4 border-red-500 p-6 mb-4" data-id="element-7551">
              <p className="text-gray-800 mb-2" data-id="element-7552">
                <strong data-id="element-7553">Symptoms of Stuck Vanes:</strong>
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-700" data-id="element-7554">
                <li data-id="element-7555">Sacrificed performance</li>
                <li data-id="element-7556">Excessive turbo lag</li>
              </ul>
            </div>

            <div className="bg-green-50 border-l-4 border-green-500 p-6 mb-4" data-id="element-7557">
              <p className="text-gray-800 mb-2" data-id="element-7558">
                <strong data-id="element-7559">Quick Fix:</strong>
              </p>
              <p className="text-gray-700" data-id="element-7560">
                The vanes can often be cleared by operating at WOT (wide open
                throttle) for a short period of time, spinning the turbine to a
                high enough RPM to free the vanes of soot.
              </p>
            </div>

            <p className="text-gray-700" data-id="element-7561">
              Additionally, the oil drain tube on early 6.0L Power Strokes is
              restrictive and can lead to turbocharger failure in some rare
              situations.
            </p>
          </div>

          {/* Oil Cooler Failure */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7562">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-7563">
              6.0L Oil Cooler Failure
            </h2>

            <p className="text-gray-700 mb-4" data-id="element-7564">
              Residual sand not removed during the casting process can clog the
              coolant side of the oil cooler. Old or sludgy oil can clog the oil
              side of the cooler. Failure can result in oil being introduced
              into the cooling system, or coolant overheating, which may result
              in serious engine damage.
            </p>

            <div className="bg-yellow-50 border-l-4 border-yellow-400 p-6 mb-4" data-id="element-7565">
              <p className="text-gray-800 mb-2" data-id="element-7566">
                <strong data-id="element-7567">Prevention Measures:</strong>
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-700" data-id="element-7568">
                <li data-id="element-7569">
                  Aftermarket coolant filters may prevent particulate from
                  clogging the coolant side
                </li>
                <li data-id="element-7570">
                  Use proper engine oil and change at recommended intervals
                </li>
                <li data-id="element-7571">
                  Aftermarket bypass oil filters may also prevent problems
                </li>
                <li data-id="element-7572">
                  Change engine coolant at recommended intervals (as recommended
                  by Ford)
                </li>
              </ul>
            </div>

            <div className="bg-red-50 border-l-4 border-red-500 p-6" data-id="element-7573">
              <p className="text-gray-800 font-semibold" data-id="element-7574">
                <strong data-id="element-7575">Critical Warning:</strong> Failure of the oil cooler has
                been related to head gasket failure. Address oil cooler issues
                immediately to prevent catastrophic engine damage.
              </p>
            </div>
          </div>

          {/* Summary of Common Issues */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7576">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-7577">
              Common 6.0L Issues Summary
            </h2>

            <div className="grid md:grid-cols-2 gap-6" data-id="element-7578">
              <div className="bg-red-50 rounded-lg p-6" data-id="element-7579">
                <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-7580">
                  Known Problem Areas:
                </h3>
                <ul className="space-y-2 text-gray-700" data-id="element-7581">
                  <li className="flex items-start" data-id="element-7582">
                    <AlertTriangle className="text-red-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7583" />
                    <span data-id="element-7584">TTY Head Bolts (especially modified engines)</span>
                  </li>
                  <li className="flex items-start" data-id="element-7585">
                    <AlertTriangle className="text-red-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7586" />
                    <span data-id="element-7587">EGR Cooler Clogging (2004+ models)</span>
                  </li>
                  <li className="flex items-start" data-id="element-7588">
                    <AlertTriangle className="text-red-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7589" />
                    <span data-id="element-7590">VGT Turbo Vane Sticking</span>
                  </li>
                  <li className="flex items-start" data-id="element-7591">
                    <AlertTriangle className="text-red-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7592" />
                    <span data-id="element-7593">Oil Cooler Failure</span>
                  </li>
                </ul>
              </div>

              <div className="bg-green-50 rounded-lg p-6" data-id="element-7594">
                <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-7595">
                  Prevention is Key:
                </h3>
                <ul className="space-y-2 text-gray-700" data-id="element-7596">
                  <li className="flex items-start" data-id="element-7597">
                    <span className="text-green-600 mr-2 flex-shrink-0 mt-1" data-id="element-7598">
                      ✓
                    </span>
                    <span data-id="element-7599">Follow manufacturer maintenance schedule</span>
                  </li>
                  <li className="flex items-start" data-id="element-7600">
                    <span className="text-green-600 mr-2 flex-shrink-0 mt-1" data-id="element-7601">
                      ✓
                    </span>
                    <span data-id="element-7602">Use high-quality diesel fuel (cetane 45+)</span>
                  </li>
                  <li className="flex items-start" data-id="element-7603">
                    <span className="text-green-600 mr-2 flex-shrink-0 mt-1" data-id="element-7604">
                      ✓
                    </span>
                    <span data-id="element-7605">Minimize excessive idling</span>
                  </li>
                  <li className="flex items-start" data-id="element-7606">
                    <span className="text-green-600 mr-2 flex-shrink-0 mt-1" data-id="element-7607">
                      ✓
                    </span>
                    <span data-id="element-7608">Regular inspections by certified mechanics</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center" data-id="element-7609">
            <h2 className="text-3xl font-bold mb-4" data-id="element-7610">
              Expert 6.0L Powerstroke Service
            </h2>
            <p className="text-xl mb-6" data-id="element-7611">
              Certified diesel mechanics ready to diagnose and repair your 6.0L
              Powerstroke
            </p>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-7612">
              <Phone className="mr-3" size={24} data-id="element-7613" />
              Call (248) 478-8382
            </a>
            <p className="mt-4 text-gray-300" data-id="element-7614">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
          </div>
        </div>
      </div>
    </div>;
}